module.exports = __webpack_public_path__ + "a31d96b8780f9b8effbc769d707a3fe9.svg";